"use client";
import React from "react";
import { useSelector } from "react-redux";

function PageLoader() {
  const { loading } = useSelector(state => state.loader);

  return (
    loading && (
      <div className="fixed inset-0 flex items-center justify-center h-screen w-screen bg-black/60 z-[99999]">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-white"></div>
      </div>
    )
  );
}

export default PageLoader;
